<template>
  <div>
    <h1 v-if="mentorType === 'Trainer'">{{ plural(mentorType) }}</h1>
    <div :class="{ 'panel panel-body': mentorType === 'Trainer' }">
      <add-trainers v-if="mentorType === 'Trainer'" @update="getMentors"></add-trainers>
      <k-panel :title="panelTitle" :showContent="show" @toggle="(val) => show = val">
        <template #body>
          <k-table :rows="kableRows" :headers="kableHeaders" :hideable="true" :panel="false" :max="10" @clicked="tableCallback"></k-table>
        </template>
      </k-panel>
    </div>
  </div>
</template>

<script>
import KPanel from '@base-components/k-panel.vue';
import KTable from '@base-components/k-table.vue';
import PageReadyMixin from '@mixins/page-ready-mixin';
import PluralMixin from '@mixins/plural-mixin';
import MentorMixin from '@mixins/mentor-mixin';
import AddTrainers from './add-trainers.vue';

export default {
  components: {
    AddTrainers,
    KTable,
    KPanel,
  },

  mixins: [PageReadyMixin, MentorMixin, PluralMixin],

  props: {
    mentorType: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      show: true,
      mentors: [],
      updating: false,
      mentorsReady: false,
    };
  },

  beforeMount() {
    this.$Loading.start();
    this.getMentors();
  },

  watch: {
    mentorType() {
      if (this.mentorType) {
        this.getMentors();
      }
    },
  },

  computed: {
    ready() {
      return !this.updating && this.mentorsReady;
    },
    panelTitle() {
      return this.plural(this.mentorType);
    },
    canUpdateLink() {
      if (this.mentorType === 'Coach') {
        return this.$permissions.hasPermission('manage_coaches');
      }
      if (this.mentorType === 'Data Mentor') {
        return this.$permissions.hasPermission('manage_mentors');
      }
      return false;
    },
    kableHeaders() {
      return {
        id: {
          name: 'ID',
          sortable: true,
        },
        name: {
          name: this.mentorType,
          sortable: true,
          filterable: true,
          type: 'url',
        },
        email: {
          name: 'Email',
          sortable: true,
          filterable: true,
        },
      };
    },
    kableRows() {
      return this.mentors.map((x, index) => (this.createRow(x, index)));
    },
  },
  methods: {
    createRow(mentor) {
      return {
        id: mentor.id,
        name: {
          text: mentor.name,
          path: {
            name: 'dashboard_students',
            params: {
              studentId: mentor.id,
            },
          },
        },
        email: mentor.email,
      };
    },
    getMentors() {
      this.mentorsReady = false;
      this.$logger.info(`Getting ${this.plural(this.mentorType.toLowerCase())}`);
      this.$http.get(`/api/profile/${this.mentorField}`).then(res => {
        this.$logger.info(`Successfully retrieved ${this.plural(this.mentorType.toLowerCase())}`);
        this.mentors = res.data[this.plural(this.mentorField)];
        this.$emit('data-fetched', { mentorType: this.mentorType, data: this.mentors });
      }).catch(err => {
        this.$logger.error(`There was an error while attempting to retrieve ${this.plural(this.mentorType.toLowerCase())}`, undefined, err);
        this.$ktoast.showError(err);
      }).then(() => {
        this.mentorsReady = true;
      });
    },
  },
};
</script>
